import React from 'react';
export const Banner30DataSource = {
  wrapper: { className: 'banner3' },
  textWrapper: {
    className: 'banner3-text-wrapper',
    children: [
      {
        name: 'slogan',
        className: 'banner3-slogan',
        children: '人才招聘 欢迎前来投简历!',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name',
        children: (
          <span>
            <span>
              <span>
                <p>亲，很高兴在这里与你相遇，能在这里找到我</p>
              </span>
            </span>
          </span>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button l5m69i8p74m-editor_css',
        children: (
          <span>
            <span>
              <p>人才招聘</p>
            </span>
          </span>
        ),
      },
      {
        name: 'time',
        className: 'banner3-time',
        children: (
          <span>
            <p>@江西融云网络科技有限公司</p>
          </span>
        ),
      },
    ],
  },
};
export const Content90DataSource = {
  wrapper: {
    className: 'home-page-wrapper content9-wrapper l5m421a2598-editor_css',
  },
  page: { className: 'home-page content9 l5m45d1lp7g-editor_css' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
        className: 'title-image',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>人才招聘</p>
          </span>
        ),
        className: 'title-h1',
      },
    ],
  },
  block: {
    className: 'timeline',
    children: [
      {
        name: 'block~l5m4q81dh2s',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <span>
                    <p>公司介绍</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>江西融云网络科技有限公司</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <span>
                    <p>软件公司</p>
                  </span>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>公司介绍</p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>
                              <span>
                                公司地址：江西省九江市濂溪区十里老街C4栋C4层1499号
                              </span>
                              <br />
                            </p>
                            <p>公司规模：20-50人</p>
                            <p>公司性质：私企</p>
                            <p>公司行业：互联网</p>
                            <p>
                              联系方式：0792-8159222<br />
                            </p>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>高级程序员</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <p>
                    最低学历：\t专科，职位月薪：\t5000-8000，招聘人数：\t1-3人，职位类别：\t项目主管
                  </p>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <p>职位描述</p>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m46a43oko-editor_css',
            children: (
              <span>
                <span>
                  <p>岗位职责： </p>
                  <p>1、负责公司主要产品项目的功能开发；</p>
                  <p> 2、负责公司产品项目的功能测试；</p>
                  <p>
                    {' '}
                    3、配合项目技术经理制定产品开发上线和实施计划，并保证计划执行；
                  </p>
                  <p> 4、配合编制公司内部产品开发的流程要求及开发规范； </p>
                  <p>
                    5、参与公司主要产品搭建项目的核心代码开发及关键问题的解决；
                  </p>
                  <p> 6、负责公司产品开发项目平台的安装部署。 </p>
                  <p>任职要求： </p>
                  <p>1、计算机或相关专业本科学历以上； </p>
                  <p>
                    2、熟练JAVA语言、精通J2EE构架，熟练使用Struts，Spring，Hibernate，Mybatis，Maven，WebService，Ajax，XML，Linux等软件开发与工程管理技术；{' '}
                  </p>
                  <p>
                    3、对JVM原理有一定的了解；处理线上问题有一定经验，熟悉应用服务器的安装、调试、配置及使用；{' '}
                  </p>
                  <p>
                    4、熟练使用ORACLE，MYSQL等关系型数据库的一种或几种，具有数据库开发能力，熟悉存储过程编写；
                  </p>
                  <p>
                    {' '}
                    5、具备需求分析和系统设计能力，以及较强的逻辑分析和独立解决问题能力；{' '}
                  </p>
                  <p>
                    6、具有良好的团队合作精神和与人沟通的能力；能够承担一定的工作压力。
                  </p>
                  <p> 面试时可带上自己的作品，以便进行作品演示。谢谢</p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>系统集成售前工程师</p>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <p>
                  工作经验：\t5年以上，最低学历：\t专科，职位月薪：\t面议，招聘人数：\t1-3人，职位类别：\t项目主管
                </p>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <p>职位描述</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4j77e18m-editor_css',
            children: (
              <span>
                <p>基本职责：</p>
                <p>1、以丰富的行业经验和项目实施经验引导客户需求；</p>
                <p>
                  2、为客户提供完善、优秀的设计方案，保障各类项目的顺利实施。
                </p>
                <p>专业能力要求：</p>
                <p>1、计算机或通信工程等相关专业本科以上学历，英语良好；</p>
                <p>
                  2、五年以上系统集成行业工作经验，熟悉国内外主流厂商的产品和网络技术；
                </p>
                <p>3、有大型系统集成项目方案设计和竞标经验；</p>
                <p>4、具有售后实施经验和项目管理经验；</p>
                <p>
                  5、对网络系统、数据中心、云计算等技术有深刻认识，能够分析、比较各主流厂商的技术和产品；
                </p>
                <p>6、良好写作及表达能力</p>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>java研发工程师</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <p>
                  工作经验：\t不限，最低学历：\t专科，职位月薪：\t面议，招聘人数：\t1-3人，\t职位类别：\t项目主管
                </p>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>职位描述</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <p>基础职责：</p>
                  <p> 1、负责公司主要产品项目的功能开发；</p>
                  <p> 2、负责公司产品项目的功能测试；</p>
                  <p>
                    {' '}
                    3、配合项目技术经理制定产品开发上线和实施计划，并保证计划执行；
                  </p>
                  <p> 4、配合编制公司内部产品开发的流程要求及开发规范； </p>
                  <p>
                    5、参与公司主要产品搭建项目的核心代码开发及关键问题的解决；
                  </p>
                  <p> 6、负责公司产品开发项目平台的安装部署。</p>
                  <p> 任职资格： </p>
                  <p>1、计算机或相关专业专科学历以上；</p>
                  <p>
                    {' '}
                    2、熟练JAVA语言、精通J2EE构架，熟练使用Struts，Spring，Hibernate，Mybatis，Maven，WebService，Ajax，XML，Linux等软件开发与工程管理技术；
                  </p>
                  <p>
                    {' '}
                    3、对JVM原理有一定的了解；处理线上问题有一定经验，熟悉应用服务器的安装、调试、配置及使用；
                  </p>
                  <p>
                    {' '}
                    4、熟练使用ORACLE，MYSQL等关系型数据库的一种或几种，具有数据库开发能力，熟悉存储过程编写；
                  </p>
                  <p>
                    5、具备需求分析和系统设计能力，以及较强的逻辑分析和独立解决问题能力；
                  </p>
                  <p>
                    {' '}
                    6、具有良好的团队合作精神和与人沟通的能力；能够承担一定的工作压力。
                  </p>
                  <p> 面试时可带上自己的作品，以便进行作品演示。谢谢</p>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~l5m4malvlba',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>产品需求分析师</p>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <p>
                    工作经验：\t1-3年，最低学历：\t专科，职位月薪：\t面议，招聘人数：\t1-3人，职位类别：\t项目主管
                  </p>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>职位描述</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>
                        <span>岗位职责：</span>
                        <br />
                      </p>
                    </span>
                  </span>
                  <p>
                    1、参与产品（项目）的市场调研、产品规划，提交产品可研报告及规划建议书；
                  </p>
                  <p>
                    2.
                    负责产品（项目）的业务需求，客户需求调研、系统业务规划、业务访谈调查、业务流程分析，产出调研报告；
                  </p>
                  <p>
                    3、负责产品（项目）的功能规划、需求分析、功能设计，输出SRS、PRD、原型等文档；
                  </p>
                  <p>4、负责产品功能面向销售、售前、实施的内部培训。</p>
                  <p>任职要求：</p>
                  <p>1、本大专及以上学历，计算机相关专业；</p>
                  <p>2、熟练使用Axure、Xmind、Visio等设计工具；</p>
                  <p>3、具有较强的沟通能力，逻辑思维能力和文档编写能力；</p>
                  <p>4、掌握需求分析方法，熟悉需求管理和研发过程管理；</p>
                  <p>5、较强的责任心及团队合作精神，能够承担工作压力。</p>
                  <span>
                    <span>
                      <p>
                        {' '}
                        6、具有良好的团队合作精神和与人沟通的能力；能够承担一定的工作压力。
                      </p>
                      <p> 面试时可带上自己的作品，以便进行作品演示。谢谢</p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~l5m4q5qtz7u',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <span>
                    <p>实施工程师</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <span>
                    <p>
                      工作经验：\t1-3年，最低学历：\t专科，职位月薪：\t3000-5000，招聘人数：\t1-3人，职位类别：\t项目主管
                    </p>
                  </span>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>职位描述</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>主要职责：</p>
                        <p>
                          1、负责软件系统现场实施工作，含实施环境搭建、系统配置、初始化等；
                        </p>
                        <p>
                          2、协助配置管理质量的控制，含准确性、完整性和实时性等；
                        </p>
                        <p>3、组织建立实施文档体系工作；</p>
                        <p>
                          4、负责公司内外关于系统实施的协调和沟通工作，具有出差能力。
                        </p>
                        <p>要求：</p>
                        <p>1、具有专科及以上学历；</p>
                        <p>2、1年以上软件项目实施工作经验。</p>
                        <p>
                          3、专业技能：熟练掌握oracle、sqlserver等数据库的操作以及相关语句的编写，iis网站的部署、网站的相关的问题解决；
                        </p>
                        <p>
                          4、具有良好的数据分析归纳能力，能及时发现体系运行中存在的问题，跟踪解决；
                        </p>
                        <p>
                          5、有一定的文字和口头表述能力，做好项目文档，撰写总结（PPT）。
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~l5m4q6grn0d',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <span>
                    <p>售前方案工程师</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>
                        工作经验：\t1-3年，工作性质：\t全职，最低学历：\t专科，职位月薪：\t面议，招聘人数：\t1-3人，<br />职位类别：\t项目主管
                      </p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>职位描述</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>职责描述：</p>
                        <p>
                          1、需求分析：技术支撑销售，完成客户需求调研和梳理工作，引导客户进行专业的需求梳理；
                        </p>
                        <p>
                          2、方案输出：根据客户需求进行规划、项目建议书、可研方案、解决方案、设计方案的文案输出；
                        </p>
                        <p>
                          3、投标支持：支持项目投标，编写技术方案、软硬件配置及报价、审核标书、现场讲标等，确保项目中标；
                        </p>
                        <p>
                          4、售前方案储备库的维护：定期调研公司产品相关行业发展趋势、竞品分析、技术路线等，对公司已有产品解决方案资料进行按需更新，同时结合公司现有产品和业务，不断提出新的、有一定前瞻性的解决方案和设计方案，为开拓新市场、新客户做好项目方案储备。
                        </p>
                        <p>
                          5、团队协作：协助团队累积客户资源、供应链资源、组织过程资产优化，完成客户或项目需要的事务性工作。
                        </p>
                        <p>任职要求：</p>
                        <p>
                          该岗位重点负责公司软件产品、系统集成和智慧展馆设计类项目的售前支持工作，具体要求如下
                        </p>
                        <p>1、计算机相关专业，本科以上学历；</p>
                        <p>
                          2、需具备3年及以上信息化行业售前、解决方案、产品经理岗位工作经验，有电子政务、智慧展馆项目工作经验者优先；
                        </p>
                        <p>
                          3、具备良好的解决方案编制能力、讲解能力、系统演示能力，能根据不同客户类型，用不同的方式进行表述；
                        </p>
                        <p>
                          4、具备一定的行业经验熟悉教育行业信息化者优先，熟悉招投标流程、系统集成、软件开发、项目管理者优先；
                        </p>
                        <p>
                          5、具备良好的职业素养，拥有积极的价值观，与人为善；
                        </p>
                        <p>
                          6、具备创新和主动学习能力，有明确的职业规划和自我要求，能适应出差。
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block~l5m4q72yas',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          textWrapper: { className: 'text-wrapper' },
          img: {
            className: 'block-img',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/SlFgHDtOTLzccvFrQHLg.png',
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <span>
                    <p>高级系统工程师</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>九江研发事业部</p>
              </span>
            ),
          },
          time: {
            className: 'block-time',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <p>
                        工作经验：\t1-3年，工作性质：\t全职，最低学历：\t专科，职位月薪：\t5000-8000，招聘人数：\t1-3人，<br />&nbsp;职位类别：\t项目主管<br />
                      </p>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          title: {
            className: 'block-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>职位描述</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'block-content l5m4kwupph-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>岗位职责：</p>
                        <p>
                          {' '}
                          1、
                          负责数据中心机房内私有云系统的管理，包括部署虚拟服务器，调试、更改配置、迁移、备份、恢复等操作，定期备份系统并检查运行情况，并按照规范进行记录工作；
                        </p>
                        <p>
                          {' '}
                          2、
                          负责数据中心机房内储系统的操作，包括划分、调配资源，并按照规范定期整理使用资源情况并汇总；
                        </p>
                        <p>
                          {' '}
                          3、
                          负责数据中心机房内的服务器维护，包括数据库服务器、FTP服务器、IIS的配置等；
                        </p>
                        <p>
                          {' '}
                          4、
                          负责数据中心机房内服务器的操作。包括安装，调试，安装虚拟机，快照备份恢复、服务器的调试等操作；
                        </p>
                        <p>
                          {' '}
                          5、 负责数据中心机房内虚拟机的操作，包括安装、调试等；
                        </p>
                        <p>
                          {' '}
                          6、
                          负责对基础设施环境进行维护，统计机房基础设施环境概况。{' '}
                        </p>
                        <p>任职要求：</p>
                        <p>
                          {' '}
                          1、熟悉华为、VMware、Citrix、Microsoft等云计算虚拟化产品，有相关规划设计、安装部署、售后运维经验；
                        </p>
                        <p>
                          {' '}
                          2、精通Windows、Linux操作系统；熟悉MicrosoftSymantec等厂商的邮件、备份等系统规划部署，熟悉服务器集群搭建，配置和维护；
                        </p>
                        <p>
                          {' '}
                          3、熟悉MySQL、SQL
                          Severr、ORACLE等数据库安装、操作及维护；{' '}
                        </p>
                        <p>
                          {' '}
                          4、熟悉服务器（PC
                          Server小型机）硬件、常规存储产品，从事过安装、配置、故障解决等相关工作；
                        </p>
                        <p>
                          {' '}
                          5、良好的沟通，语言表达，协调，文档编辑能力；踏实，能吃苦，学习能力强，工作主动性强，良好的团队合作精神；
                        </p>
                        <p>
                          {' '}
                          6、熟悉政府、教育、医疗行业，有在政府、教育、医疗行业做过项目实施、系统运维；有MCSEVCPHCNPHCIE等证书优先。
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
    ],
  },
};
